<template>
<div style="overflow-x: hidden; margin: 0; padding: 0" class="container-fluid">
    <div class="motomoto_nav">
        <div class="icons">
            <img src="../../assets/motomoto.svg" alt="" srcset="">
            <button class="lgout" @click.prevent="logout" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Log Out">
                <img src="../../assets/logout.svg" alt="" srcset="" width="25px">
            </button>
        </div>
    </div>
    <div class="row">
        <div style="margin-top: 50px; padding: 0;" class="col-lg-2">
            <nav style="" class="sidebar">
                <section class="py-4 ps-4 pe-3">
                    <div class="d-flex mt-4 mb-3 justify-content-start">
                        <img class="rounded-circle" width="37" height="37" src="../../assets/user.svg" alt="user image" />
                        <div class="ms-3">
                            <h6 class="name m-0">{{userFirstName}} {{userlastName}}</h6>
                            <small class="email">{{userEmail}}</small>
                        </div>
                    </div>
                    <ul style="color: #fff" class="nav flex-column" id="nav_accordion">
                        <li class="nav-item mt-3">
                            <a class="nav-link" href="dash.php">
                                <img src="../../assets/dashboard.svg" alt="icons" />
                                <span class="link-item-text ms-3">Dashboard</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="collapse" data-bs-target="#menu_item1" href="#">
                                <!-- <img src="@/assets/icons/settings.svg" alt="icons" /> -->
                                <span style="font-size: 25px; color: #fff"><i class="fas fa-cog"></i></span>
                                <span class="link-item-text mx-3">State</span>
                                <i class="bi small bi-caret-down-fill"></i>
                            </a>
                            <ul id="menu_item1" class="submenu collapse" data-bs-parent="#nav_accordion">
                                <li>
                                    <router-link class="link_li" to="/enrol">Enroll State</router-link>
                                </li>
                                <li>
                                    <router-link class="link_li" to="/enroled">States Enrolled</router-link>
                                </li>
                                <li>
                                    <router-link class="link_li" to="/stateadmin">Create State Admin</router-link>
                                </li>
                                <li>
                                    <router-link class="link_li" to="/listinstadmin">List State Admin</router-link>
                                </li>
                            </ul>
                        </li>

                        <li class="nav-item">
                            <a class="nav-link" data-bs-toggle="collapse" data-bs-target="#menu_item2" href="#">
                                <!-- <img src="@/assets/icons/users.svg" alt="icons" /> -->
                                <span style="font-size: 25px; color: #fff"><i class="fas fa-folder-open"></i></span>
                                <span class="link-item-text mx-3">Services</span>
                                <i class="bi small bi-caret-down-fill"></i>
                            </a>
                            <ul id="menu_item2" class="submenu collapse" data-bs-parent="#nav_accordion">
                                <li>
                                    <router-link class="link_li" to="/services">Add/List Services</router-link>
                                </li>
                                <li>
                                    <router-link class="link_li" to="/items">Add/List Items</router-link>
                                </li>
                                <li>
                                    <router-link class="link_li" to="/documents">Add/List Documents</router-link>
                                </li>
                                <!-- <li><a class="link_li" href="#">Submenu item 6 </a></li> -->
                            </ul>
                        </li>
                        <li class="nav-item mt-3">
                            <a class="link_li" href="#">
                                <!-- <img src="@/assets/icons/invoices.svg" alt="icons" /> -->
                                <!-- <span class="link-item-text ms-3">Invoices</span> -->
                            </a>
                        </li>
                    </ul>
                </section>
            </nav>
        </div>
        <div class="route_view col-lg-10">
            <div style="margin-top: 50px; padding: 20px 0;">
                <router-view />
            </div>
        </div>
    </div>
</div>

<!-- ============================================================== -->
<!-- End Page content -->
<!-- ============================================================== -->
</template>

<script>
import Swal from 'sweetalert2'
// import sideNav from "../appmart/SideNav.vue"
import $ from 'jquery'
import router from '@/router/index'

// @ is an alias to /src
import cookieOps from "@/services/cookieOps.js";
import httpRequest from "@/services/httpRequests.js";

export default {
    name: 'appmartDash',
    data() {
        return {
            admin: null,
            user: null,
            thiscookie: '',
            userEmail: '',
            userFirstName: '',
            userlastName: '',
        };
    },

    mounted() {
        // console.log(this.thiscookie);
        // console.log(this.$route);
        // console.log('Params: ', this.$route.query)
        this.userFirstName = this.$route.query.user.firstName
        this.userlastName = this.$route.query.user.lastName
        this.userEmail = this.$route.query.user.email
        // ({ email: this.userEmail, firstName: this.userFirstName } = this.$route.query);
        // console.log(user);
        // const fetchadmin = httpRequest.get('admin/institution/:854532').then(function (res) {
        //     console.log('jeg');
        //     console.log(res)
        // });
        /// check if cookie is available  
        const iscookie = cookieOps.checkCookies('app_init');
        console.log(iscookie);
        if (!iscookie) {
            router.push('login')
        } else {
            this.thiscookie == iscookie
        }
        var dropdown = document.getElementsByClassName("dropdown-btn");
        var i;
        for (i = 0; i < dropdown.length; i++) {
            dropdown[i].addEventListener("click", function () {
                this.classList.toggle("active");
                var dropdownContent = this.nextElementSibling;
                if (dropdownContent.style.display === "block") {
                    dropdownContent.style.display = "none";
                } else {
                    dropdownContent.style.display = "block";
                }
            });
        }

    },

    /// SCOPE METHODS
    methods: {
        // alertDisplay() {
        //     // $swal function calls SweetAlert into the application with the specified configuration.
        //     this.$swal('Heading', 'this is a Heading', 'OK');
        // },
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },

        ///// LOGIN FOR APPMART ADMIN

        // /// LOGOUT FOR APPMART ADMIN
        logout() {
            this.alertDisplay('Logged Out', 'Admin Loged out', 'success');
            this.$cookies.remove()
            localStorage.clear();
            this.$router.push({
                path: '/'
            });

        }

    },

    // //Importing the Side nAV
    // components: {
    //     sideNav
    // }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

body {
    min-height: 100vh;
    min-height: -webkit-fill-available;
}

.link_li {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    align-items: center;
    color: #FFFFFF;
    margin-left: 20px;
    padding: 10px 20px;
    /* background: #fff; */
}

.link_li:hover {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    align-items: center;
    color: #ce9f9f;
    margin-left: 20px;
    /* padding-left: 20px; */
    /* transition-delay: 0.5s ease; */
}

@media (max-width: 1000px) {
    .link_li {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 18px;
        align-items: center;
        color: #FFFFFF;
        margin-left: 20px;
        padding: 10px 20px;
        /* background: #fff; */
    }

    .link_li:hover {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        align-items: center;
        color: #ce9f9f;
        margin-left: 20px;
        /* padding-left: 20px; */
        /* transition-delay: 0.5s ease; */
    }
}

nav {
    color: white
}

nav:hover {
    color: #fff;
}

nav:active {
    color: #fff;
}

.name {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #FFFFFF;
}

.email {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #FFFFFF;
}

.sidebar {
    height: 100vh;
    width: auto;
    margin: 0;
    background: #555A6E;
    margin: 0;
    padding: 0;
    height: 100%;
    overflow: auto;
}

.sidebar:hover {
    color: #fff;
}

.sidebar:active {
    color: #fff;
}

@media (max-width: 1000px) {
    .sidebar {
        width: 100%;
        height: auto;
        position: relative;
        margin-top: 20px;
    }
}

.lgout {
    text-decoration: none;
    background: none;
    border: none;
}

.route_view {
    height: 100vh;
    /* max-height: 100%; */
    margin: 0;
    padding-left: 0;
    padding-right: 20px;
    padding-top: 20px;
    background: #E5E5E5;

    /* width: 100vw; */
    /* height: 100%; */
    min-height: 100%;
    box-sizing: border-box;
    overflow-x: hidden;
    /* overflow-y: hidden; */
}

@media (max-width: 1000px) {
    .route_view {
        height: 100vh;
        margin: 0;
        padding-left: 0;
        padding-right: 20px;
        padding-top: 30px;
        background: #E5E5E5;
    }
}

.icons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.motomoto_nav {
    width: 100%;
    height: auto;
    padding: 15px 30px;
    background: #FFFFFF;
    position: fixed;
}

.ps-4 {
    padding-left: 2.188rem !important;
}

h6 {
    font-size: 1rem;
    font-weight: 700;
    color: #fff;
}

small {
    color: #fff;
    font-size: 0.75rem;
    font-weight: 400;
}

.link-item-text {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    align-items: center;
    color: #FFFFFF;
}

.bi {
    color: #fff;
}

li {
    list-style: none;
    font-size: 28px;
}

li:hover {
    color: #fff;
}

li:active {
    color: #fff;
}

a {
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: 500;
    color: #fff;
}

a:hover {
    color: #fff;
}

a:active {
    color: #fff;
}
</style>
